import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Form } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import { BalanceVO } from 'src/app/shared/models/BalanceVO';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { Form0 } from 'src/app/shared/models/Form0';
import { GuideModel } from 'src/app/shared/models/guide-model';
import { GuideMatDtlVO } from 'src/app/shared/models/GuideMatDtlVO';
import { GuideMatSRDtl } from 'src/app/shared/models/GuideMatSRDtl';
import { MaterialBorrow } from 'src/app/shared/models/MaterialBorrow';
import { PeriodsVO } from 'src/app/shared/models/PeriodsVO';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { Store } from 'src/app/shared/models/Store';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { Wstype } from 'src/app/shared/models/Wstype';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { AuthenticationService } from 'src/app/_services';

@Component({
  selector: 'app-dashboarstsguides',
  templateUrl: './dashboarstsguides.component.html',
  styleUrls: ['./dashboarstsguides.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class DashboarstsguidesComponent implements OnInit {
  lstItems: GuideMatDtlVO[];
  lstSum: GuideMatSRDtl[] = [];
  token: string;
  security: SecurityDocument;
  guide: GuideModel;
  store: Store;
  materialBorrow: MaterialBorrow[];
  borrowItems?: string;
  guideOffer?: BalanceVO;
  guideAnnualQ?: BalanceVO;
  guideFunda?: BalanceVO;
  pendAmount: Number;
  categoryLan: CategoryLan;
  statusGuide: string;
  quitDesc: string = "";
  listPeriods: PeriodsVO[];
  selectedPeriod: PeriodsVO;
  lstForm0: Form0[] = [];
  mapServices = new Map();
  device: string;

  lstRespTranslate: TranslateRelLabelVO[];
  lbl_status: string = "status_";
  lbl_period: string = "period_";
  lbl_select: string = "select_";
  lbl_search: string = "search_";
  lbl_guide: string = "guide_";
  lbl_coordination: string = "coordination_";
  lbl_id: string = "id_";
  lbl_certificate: string = "certificate_";
  lbl_sent_Date: string = "sent_Date_";
  lbl_manuals: string = "manuals_";
  lbl_distictives: string = "distictives_";
  lbl_offering: string = "offering_";
  lbl_material_balance: string = "material_balance_";
  lbl_description: string = "description_";
  lbl_type: string = "type_";
  lbl_quantity: string = "quantity_";
  lbl_item: string = "item_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_records: string = "records_";
  lbl_loading: string = "loading_";
  lbl_total: string = "total_";
  lbl_services: string = "services_";
  lbl_schedule: string = "schedule_";
  lbl_1a2a_partic: string = "1a2a_partic_";
  lbl_10a15a_particip: string = "10a15a_particip_";
  lbl_annual_quote: string = "annual_quote_";



  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private authenticationService: AuthenticationService

  ) {
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
          this.device = params.device;
        });
    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      } else {
        this.getSecurity();
      }
    }

  }

  ngOnInit(): void {
  }
  getSecurity() {

    this.apiService.findSecurityById({ "id": this.token }).then(
      data => {
        this.security = data;
        if (this.security.guideId) {
          this.getValidPeriods();

        }
        this.getTranslatedLabels();


      });
  }
  getGuideMatPeriod() {
    this.lstItems = [];
    this.lstSum = [];
    let mapItemsDesc = new Map();
    let mapSelQty = new Map();
    let mapRetQty = new Map();
    this.apiService.getGuideMatPeriod({
      "guideId": this.security.guideId,
      "year": this.selectedPeriod.year,
      "period": this.selectedPeriod.period
    }).then(
      data => {
        this.lstItems = data;
        for (let i = 0; i < this.lstItems.length; i++) {
          mapItemsDesc.set(this.lstItems[i].itemId, this.lstItems[i].descri);
          if (this.lstItems[i].docType == 'S') {
            mapSelQty.set(this.lstItems[i].itemId, this.lstItems[i].quantity);

          } else {
            mapRetQty.set(this.lstItems[i].itemId, this.lstItems[i].quantity);
          }
        }
        mapItemsDesc.forEach((val, key) => {

          this.lstSum.push({ itemId: val, descri: key, sellQuantity: mapSelQty.get(key), returnQuantity: mapRetQty.get(key) });
        });
      }).catch(error => {

        console.error(error);
      });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstCat: CategoryLan[];

    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_status, this.lbl_period, this.lbl_select, this.lbl_search, this.lbl_guide, this.lbl_coordination, this.lbl_id, this.lbl_certificate, this.lbl_sent_Date, this.lbl_manuals, this.lbl_distictives, this.lbl_offering, this.lbl_material_balance, this.lbl_description, this.lbl_type, this.lbl_quantity, this.lbl_item, this.lbl_showing, this.lbl_of, this.lbl_records, this.lbl_loading, this.lbl_total, this.lbl_services, this.lbl_schedule, this.lbl_1a2a_partic, this.lbl_10a15a_particip, this.lbl_annual_quote]
    }).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_status = map.get(this.lbl_status);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_period = map.get(this.lbl_period);

        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_id = map.get(this.lbl_id);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_sent_Date = map.get(this.lbl_sent_Date);
        this.lbl_manuals = map.get(this.lbl_manuals);
        this.lbl_distictives = map.get(this.lbl_distictives);
        this.lbl_offering = map.get(this.lbl_offering);
        this.lbl_material_balance = map.get(this.lbl_material_balance);
        this.lbl_description = map.get(this.lbl_description);
        this.lbl_type = map.get(this.lbl_type);
        this.lbl_quantity = map.get(this.lbl_quantity);
        this.lbl_item = map.get(this.lbl_item);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_loading = map.get(this.lbl_loading);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_services = map.get(this.lbl_services);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_1a2a_partic = map.get(this.lbl_1a2a_partic);
        this.lbl_10a15a_particip = map.get(this.lbl_10a15a_particip);
        this.lbl_annual_quote = map.get(this.lbl_annual_quote);




      });
  }
  getGuideById() {
    this.apiService.getGuideById({ "guideId": this.security.guideId }).then(
      data => {
        this.guide = data;
        if (this.guide) {
          this.getCategoryTranslation("guideSts", this.guide.status);
          if (this.guide.status == 'B') {
            this.getCategoryTranslation("quitType", this.guide.quitType);
          }
        }

      });
  }
  getStoreById() {
    this.apiService.getStoreById({ "storeId": this.security.storeId }).then(
      data => {
        this.store = data;
      });
  }
  getMaterialsBorrowByGuide() {
    this.apiService.getMaterialsBorrowByGuide({
      "guideId": this.security.guideId
    }).then(
      data => {
        this.materialBorrow = data;
        this.borrowItems = '';
        this.materialBorrow.forEach((element) => {
          this.borrowItems = this.borrowItems + element.itemDescripcion + '->' + element.folio + ',  ';
        })
      });
  }
  getBalanceByConceptDates(concept: string, per: string) {
    this.apiService.getBalanceByConceptDates({
      "guideId": this.security.guideId,
      "year": this.selectedPeriod.year,
      "period": per,
      "incExpId": concept
    }).then(
      data => {
        if (concept == "OI") {
          this.guideOffer = data;
        } else if (concept == "AC") {
          this.guideAnnualQ = data;
        } else if (concept == "ED") {
          this.guideFunda = data;
        }


      });
  }
  getGuideBalance() {
    let lstBal: BalanceVO[];
    this.pendAmount = 0;
    this.apiService.getGuideBalance(
      {
        "guideId": this.security.guideId,
      }
    ).then(
      data => {
        lstBal = data;

        lstBal.forEach((element) => {

          if (element.concept.trim() == 'ADEUDO TOTAL') {

            if (element.amount > 1) {
              this.pendAmount = element.amount;
            }
          }
        });
      }
    );
  }
  getCategoryTranslation(fieldId: string, value: string) {
    let result: string[];
    this.apiService.getCategoryTranslation({
      "language": this.security.language,
      "fieldId": fieldId,
      "fieldVal": value
    }).then(
      data => {
        result = data;

        if (fieldId == "guideSts") {

          this.statusGuide = result[0];
        } else if (fieldId == "quitType") {
          this.quitDesc = result[0];
        }

      });
  }
  getValidPeriods() {
    this.apiService.getValidPeriods(this.security.language).then(
      data => {
        this.listPeriods = data;
        this.selectedPeriod = this.listPeriods[0];
        this.search();
      });
  }
  search() {
    this.getGuideById();
    this.getGuideMatPeriod();
    this.getStoreById();
    this.getMaterialsBorrowByGuide();
    this.getBalanceByConceptDates("OI", this.selectedPeriod.period);
    this.getBalanceByConceptDates("AC", "");
    this.getBalanceByConceptDates("ED", "");
    this.getGuideBalance();

    this.listTranslatedServices();

  }

  listTranslatedServices() {
    let lstTypes: Wstype[];
    this.apiService.listTranslatedServices({
      "language": this.security.language

    }).then(
      data => {
        lstTypes = data;
        lstTypes.forEach((element) => {
          this.mapServices.set(element.wsId, element.wsShrName);
        })
        this.form0_findBy_Period_Guide();
      });

  }
  form0_findBy_Period_Guide() {
    let lstForm0_tmp: Form0[];
    let ct: number = 0;
    this.apiService.form0_findBy_Period_Guide({
      "guideId": this.security.guideId,
      "anio": this.selectedPeriod.year,
      "period": this.selectedPeriod.period,

    }).then(
      data => {
        lstForm0_tmp = data;
        lstForm0_tmp.forEach((element) => {
          element.serTyp = this.mapServices.get(element.serTyp);
          element.fromTime = this.tovpilUtils.formatHours(element.fromTime);
          element.toTime = this.tovpilUtils.formatHours(element.toTime);
          this.lstForm0[ct] = element;

          ct = ct + 1;
        })


      });
  }
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
          }
        },
        error => {
        });
  }
}
